<template>
    <el-card class="box-card" shadow="always">
        <div class="title_btn">
            <div>*行业痛点</div>
            <el-button type="primary" @click="addNum">添加</el-button>
        </div>

        <div class="banner_list">
            <div class="list">
                <div class="form-item">
                    <div class="title">*排列序号</div>
                    <div class="title">*标题+图片<div class="el-upload__tip">建议尺寸为100*100</div></div>
                    <div class="title">*文字描述</div>
                </div>

                <div v-for="(index) in num" :key="index" class="form-item co_m">
                    <el-input-number v-model="pain_points_item[index-1].sort" :min="1" clearable class="name-input" placeholder="请输入排列序号" /></el-input-number>
                    <div class="title_img name-input">
                        <el-input v-model="pain_points_item[index-1].title" clearable class="name-input market" placeholder="多元化营销方式：" />
                        <imageUpload v-model="pain_points_item[index-1].img_list" :limit="1" />
                    </div>
                    <el-input v-model="pain_points_item[index-1].dec" type="textarea" :autosize="{ minRows: 3, minCols:20}" clearable class="name-input" placeholder="请输入文字描述" />
                    <div v-show="index!=1" class="form-item el-icon-remove" @click="delectNum(index-1)"></div>
                </div>
            </div>
        </div>

        <div class="case_left">
            <div class="case-item">
                <span class="label">*行业背景</span>
                <div>
                    <imageUpload v-model="industryInfo.industryBgImg" :limit="1" />
                    <div class="el-upload__tip">建议尺寸为1920*540</div>
                </div>

            </div>

            <div class="case-item customize">
                <span class="label">自定义ALT</span>
                <el-input v-model="industryInfo.industry_background_img_alt" placeholder="请输入自定义ALT"></el-input>
            </div>
        </div>

        <div>
            <div class="title_btn">
                <div>*解决方案</div>
                <el-button type="primary" @click="addSolution">添加</el-button>
            </div>

            <div class="banner_list">
                <div class="list">
                    <div class="form-item">
                        <div class="title">*排列序号</div>
                        <div class="title">*标题+图片<div class="el-upload__tip">建议尺寸为630*482</div></div>
                        <div class="title">*文字描述</div>
                    </div>

                    <div v-for="(index) in solu_num" :key="index" class="form-item co_m">
                        <el-input-number v-model="solution_item[index-1].sort" :min="1" clearable class="name-input" placeholder="请输入排列序号" /></el-input-number>
                        <div class="title_img name-input">
                            <el-input v-model="solution_item[index-1].title" clearable class="name-input market" placeholder="多元化营销方式：" />
                            <imageUpload v-model="solution_item[index-1].img_list" :limit="1" />
                        </div>
                        <el-input v-model="solution_item[index-1].dec" type="textarea" :autosize="{ minRows: 3, minCols:20}" maxlength="200" clearable class="name-input" placeholder="请输入文字描述" />
                        <div v-show="index!=1" class="form-item el-icon-remove" @click="delectSolution(index-1)"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="seo_module">
            <div class="seo_set">*架构图</div>
            <div class="seo_wrap">
                <div>
                    <div class="structure-item">
                        <span class="label">*标题：</span>
                        <el-input v-model="industryInfo.framework_title" clearable style="width: 300px" class="name-input" placeholder="请输入标题：" />
                    </div>
                    <div class="structure-item">
                        <span class="label">自定义ALT：</span>
                        <el-input v-model="industryInfo.framework_img_alt" clearable style="width: 300px" class="name-input" placeholder="请输入自定义ALT" />
                    </div>
                </div>

                <div class="structure-item">
                    <span class="label co_w">*架构图（{{ industryInfo.frameworkImg.length }}/1）：</span>
                    <div>
                        <imageUpload v-model="industryInfo.frameworkImg" :limit="1" />
                        <div class="el-upload__tip">建议尺寸为1338*600</div>
                    </div>
                </div>
            </div>

        </div>
    </el-card>
</template>
<script>
import baseURL from '@/configs/baseUrl';
import utils from '@/jslibs/utils';
import { imgDomain } from '@/configs/env';
import imageUpload from '@/components/ImageUpload';
export default {
    components: {
        imageUpload
    },
    data() {
        return {
            num: 1,
            solu_num: 1,
            imgDomain,
            headers: {
                'X-Access-Token': utils.getCookie('X-Access-Token') || ''
            },
            baseURL,
            loading: false,
            industryInfo: {
                industry_background_img: "",
                industryBgImg: [],
                industry_background_img_alt: "",
                frameworkImg: [],
                framework_img: "",
                framework_title: "",
                framework_img_alt: ""
            },

            // 行业痛点
            pain_points_item: [
                { title: "", image: "", dec: "", sort: "", img_list: [] }
            ],

            // 解决方案
            solution_item: [
                { title: "", image: "", dec: "", sort: "", img_list: [] }
            ]
        };
    },

    methods: {
        addSolution() {
            this.solu_num++;
            this.solution_item.push({ title: "", image: "", dec: "", sort: "", img_list: [] })
        },

        delectSolution(index) {
            this.solu_num--;
            this.solution_item.splice(index, 1);
        },

        addNum() {
            this.num++;
            this.pain_points_item.push({ title: "", image: "", dec: "", sort: "", img_list: [] })
        },

        delectNum(index) {
            this.num--;
            this.pain_points_item.splice(index, 1);
        },

        verifyInput() {
            const { industryBgImg, industry_background_img_alt, frameworkImg, framework_title, framework_img_alt } = this.industryInfo;
            if (!this.pain_points_item[0].sort) {
                this.$notify.error({ title: '请输入行业痛点序号' });
                return false
            }
            if (!this.pain_points_item[0].title) {
                this.$notify.error({ title: '请输入行业痛点标题' });
                return false
            }
            if (!this.pain_points_item[0].img_list.length) {
                this.$notify.error({ title: '请上传行业痛点图片' });
                return false
            }
            if (!this.pain_points_item[0].dec) {
                this.$notify.error({ title: '请输入行业痛点描述' });
                return false
            }
            this.pain_points_item.forEach((item, index) => {
                item.image = item.img_list.join();
            })
            const pain_points_item = this.pain_points_item.filter((item, index) => {
                return (item.sort && item.title && item.image && item.dec)
            })

            if (!industryBgImg.length) {
                this.$notify.error({ title: '请上传行业背景图片' });
                return false
            }

            if (!this.solution_item[0].sort) {
                this.$notify.error({ title: '请上传解决方案序号' });
                return false
            }
            if (!this.solution_item[0].title) {
                this.$notify.error({ title: '请输入解决方案标题' });
                return false
            }
            if (!this.solution_item[0].img_list.length) {
                this.$notify.error({ title: '请上传解决方案图片' });
                return false
            }
            if (!this.solution_item[0].dec) {
                this.$notify.error({ title: '请输入解决方案描述' });
                return false
            }
            this.solution_item.forEach((item, index) => {
                item.image = item.img_list.join();
            })
            const solution_item = this.solution_item.filter((item, index) => {
                return (item.sort && item.title && item.image && item.dec)
            })

            if (!framework_title) {
                this.$notify.error({ title: '请输入架构图标题' });
                return false
            }
            if (!frameworkImg.length) {
                this.$notify.error({ title: '请上传架构图图片' });
                return false
            }
            this.industryInfo.industry_background_img = this.industryInfo.industryBgImg.join();
            this.industryInfo.framework_img = this.industryInfo.frameworkImg.join();
            this.industryInfo.pain_points_item = pain_points_item;
            this.industryInfo.solution_item = solution_item;
            return true
        }
    }
};
</script>
<style lang="less" scoped>
    .box-card{
        margin: 60px 0;
        .title_btn{
            div{
                margin-bottom: 20px;
            }
            button{
               margin-bottom: 20px;
            }
        }
        .banner_list{
            border: 1px solid #ccc;
            padding: 20px;
            .list{
                .form-item {
                    display: flex;
                    flex-wrap: wrap;
                    align-items: flex-start;
                    margin-left: 0;
                    margin-bottom: 10px;
                    .title{
                        width: 240px;
                        text-align: center;
                        margin-right: 50px;
                    }
                    /deep/ .dankal-image-upload{
                        .add-box{
                            width: 40px;
                            height: 40px;
                            margin: 0 auto;
                            padding-left: 0;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            img{
                                width: 36px;
                                height: 36px;
                            }
                        }
                        p{
                            width: 40px;
                            height: 40px;
                            margin: 0 auto;
                        }
                    }
                    .el-icon-remove{
                        font-size: 40px;
                        display: flex;
                        align-items: center;
                    }
                    .title_img{
                        display: flex;
                        margin-right: 50px;
                        border: 1px solid #8b9cac;
                        border-radius: 2px;
                    }

                    .el-textarea{
                        width: 250px;
                        margin-right: 0;
                    }
                    .img_list{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        /deep/.el-upload{
                            width: 40px;
                            height: 40px;
                            line-height:50px;
                            img{
                                width: 100%;
                                height: 100%;
                            }
                        }
                    }

                    .name-input{
                        width: 240px;
                        margin-right: 50px;
                    }
                    .market{
                        margin-right: 0;
                        border-right: 1px solid #8b9cac;
                        /deep/input{
                            border: none;
                        }
                    }
                }
            }
        }
        .case_left{
            margin: 30px 0;
            .case-item{
                display: flex;
                align-items: flex-start;
                margin-bottom: 20px;
                /deep/ .add-box{
                    padding-left: 0;
                    margin-top: 0;
                }
                .el-input{
                    width: 300px;
                }
                .label{
                    width: 100px;
                }
            }
            .customize{
                align-items: center;
            }
        }

        .seo_module{
            margin-top: 60px;
            .seo_set{
                margin-bottom: 20px;
            }
            .seo_wrap{
                display: flex;
                align-items: center;
                border: 1px solid #ccc;
                padding: 20px;
                .structure-item {
                    display: flex;
                    align-items: center;
                    margin-bottom: 30px;
                    margin-right: 80px;
                    .label{
                        width: 100px;
                        display: inline-block;
                    }
                    .co_w{
                       width: 120px;
                    }
                    /deep/ .add-box{
                        padding-left:0
                    }
                }
                .structure-item:last-child{
                    margin-bottom: 0;
                }
            }
        }
        .el-upload__tip{
            color: red;
        }
    }
</style>
